<template>
  <div class="c-epg-list-item js-epg-program-item">
    <div class="c-epg-list-item__wrapper">
      <ui-epg-indicators
        :program="program"
        :channel="channel"
        class="c-epg-list-item__indicators"
      ></ui-epg-indicators>
      <router-link
        :to="item | link"
        class="c-epg-list-item__channel"
      >
        <v-badge
          :product="channel"
          class="c-epg-list-item__badge"
        ></v-badge>
        <v-product-image
          :product="channel"
          :type="ImageType.SQUARE_MINI"
        ></v-product-image>
      </router-link>
      <router-link
        :to="channel | link"
        class="c-epg-list-item__current-program"
        :class="{ 'c-epg-list-item__current-program--disabled': program.empty || program.isPlaybackDisabled }"
      >
        <div>
          <p class="c-epg-list-item__title u-bold o-typography__body2 u-ellipsis-2-lines">
            {{ program.title || $t('glossary.emptyProgram') }}
          </p>
          <p class="c-epg-list-item__duration">
            {{ program.since | dateFormat('HH:mm') }} - {{ program.till | dateFormat('HH:mm') }}
          </p>
        </div>
        <v-progress
          class="c-epg-list-item__progress"
          :product="program"
        ></v-progress>
      </router-link>
      <ui-epg-lock-icon
        v-if="program.isPlaybackDisabled"
        is-list-item
      ></ui-epg-lock-icon>
    </div>
  </div>
</template>
<script>
  import { ImageType } from '@/shared/enums';
  import { dateFormat, link } from '@/index/shared/filters';
  import { VBadge } from '@/index/shared/components';
  import VProductImage from '../../product-image/index.vue';
  import VProgress from '../../progress/index.vue';
  import UiEpgIndicators from '../epg-indicators.vue';
  import UiEpgLockIcon from '../epg-lock-icon.vue';

  export default {
    enums: {
      ImageType,
    },
    filters: {
      link,
      dateFormat,
    },
    components: {
      VBadge,
      VProductImage,
      VProgress,
      UiEpgIndicators,
      UiEpgLockIcon,
    },
    props: {
      channel: undefined,
      filter: undefined,
    },
    computed: {
      program() {
        return (this.channel.event ? this.channel.nearestProgram : this.channel.currentProgram) || {};
      },
      item() {
        return this.channel.event ? this.channel.nearestProgram : this.channel;
      },
    },
  };
</script>
